import type { FetchError } from "node-fetch";

import fetch from "node-fetch";

export const addQueryParams = (figmaFileUrl: string, queryParams: string) => {
  if (!queryParams) {
    return figmaFileUrl;
  }

  // If there's a version defined we'll add a '&' to the end of the already defined query
  // else we'll start a query by adding '?'
  let url = figmaFileUrl;
  url += figmaFileUrl.includes("?") ? "&" : "?";
  url += queryParams;
  return url;
};

export async function getFigmaEndpoint<ResponseType>(
  figmaApiKey: string,
  figmaApiUrl: string,
) {
  if (!figmaApiKey || !figmaApiUrl) {
    throw new Error(
      'Missing one or more of required arguments: "figmaToken", "figmaUrl" when attempting to get data from Figma API!',
    );
  }

  try {
    const response = await fetch(figmaApiUrl, {
      method: "GET",
      headers: {
        "X-Figma-Token": figmaApiKey,
      },
    });

    const data = (await response.json()) as ResponseType;
    if (!data) {
      throw { code: "404" };
    }

    return data;
  } catch (e) {
    const error = e as FetchError;
    if (error.code === "404") {
      throw new Error("Could not retrieve any data.");
    }
    throw new Error(
      'Missing one or more of required arguments: "figmaToken", "figmaUrl" when attempting to get data from Figma API!',
    );
  }
}
